import { Navbar } from "react-bootstrap";
import styled from "styled-components";
import LightDarkToggle from "../components/LightDarkToggle";

const HeaderShell = styled.header`
  flex: 0 0 auto;
`;

const HeaderBar = styled(Navbar)`
  /* keep bootstrap props for bg/variant, this is just a wrapper */
`;

const Header = () => {
  return (
    <HeaderShell>
      <HeaderBar bg="primary" variant="dark" className="px-3">
        <Navbar.Brand
          className="me-3"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img height="25" src="/images/bus-stats.png" alt="Basemap logo" />
        </Navbar.Brand>
        <div
          className="me-3"
          style={{
            width: "1px",
            height: "25px",
            backgroundColor: "white",
          }}
        />

        <Navbar.Brand
          className="me-3"
          href="https://basemap.co.uk/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img width="110px" src="/images/logo.png" alt="Basemap logo" />
        </Navbar.Brand>

        <Navbar.Brand
          className="me-3"
          href="https://www.buscentreofexcellence.org.uk/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            width="110px"
            src="/images/bus_centre_of_excellence_logo.png"
            alt="Bus Centre of Excellence logo"
          />
        </Navbar.Brand>

        <div className="ms-auto d-flex gap-2">
          <LightDarkToggle />
        </div>
      </HeaderBar>
    </HeaderShell>
  );
};
export default Header;
